import React from 'react';
import showError from 'utils/errorHandler';
import { useDisclosure } from 'hooks/useDisclosure';
import { SignatureDialog } from './signature/Dialog';
import Api from './api';
import './index.scss';

const LongDistanceContract = () => {
  const { isOpen: modalOpen, open: openModal, close: closeModal } = useDisclosure();

  const [invoiceContainerHeight, setInvoiceContainerHeight] = React.useState('100vh');

  const [contract, setContract] = React.useState(null);

  const iframe = React.useRef(null);
  const containerRef = React.useRef(null);

  const queryParams = React.useMemo(() => {
    const url = new URL(window.location.href);

    return {
      jobId: url.searchParams.get('job_id'),
    };
  }, []);

  const getContract = React.useCallback(async () => {
    if (!queryParams.jobId) {
      showError({ message: 'Something went wrong. URL is broken.' });
      return;
    }

    const response = await Api.contract(queryParams.jobId);

    if (response && response.data) {
      setContract(response.data);
    }
  }, [queryParams.jobId]);

  React.useEffect(() => {
    getContract();
  }, [getContract]);

  React.useEffect(() => {
    function handleResize() {
      const { innerHeight: windowHeight } = window;
      const contentHeight = containerRef?.current?.offsetHeight;

      if (windowHeight && contentHeight && windowHeight < contentHeight) {
        setInvoiceContainerHeight(windowHeight + 'px');
      }
    }

    handleResize();

    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  return (
    <React.Fragment>
      <div className="ld-contract-invoice" style={{ height: invoiceContainerHeight }} ref={containerRef}>
        <header>
          <h1>Long Distance Contract</h1>
        </header>
        <div className="invoice-iframe-wrap">
          {contract && <iframe ref={iframe} title="invoice" src={contract.doc_url} id="contract" name="contract" className="invoice-iframe" />}
        </div>
        <footer>
          {contract &&
            (!contract.signs.ld_contract_terms_of_payment ||
              !contract.signs.ld_contract_acknowledge_client ||
              contract.insurance_option === 0 ||
              (contract.insurance_option === 1 && !contract.signs.ld_contract_interstate_bill_client) ||
              (contract.insurance_option === 2 &&
                (!contract.signs.ld_contract_interstate_bill_client_initials || !contract.signs.ld_contract_interstate_bill_client))) && (
              <button type="button" className="btn" onClick={openModal}>
                Sign
              </button>
            )}
        </footer>
      </div>

      {modalOpen && <SignatureDialog jobId={queryParams.jobId} contract={contract} onClose={closeModal} refetchContract={getContract} />}
    </React.Fragment>
  );
};

export default LongDistanceContract;
